<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal title="领券退出" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="handleCancel" :maskClosable="false">
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="state.loading" @click="onFormSubmit">立即退出</a-button>
    </template>
    <a-spin :spinning="state.loading">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
        <a-form-item label="主体名称">
          {{ props.detailData.full_name }}
        </a-form-item>
        <a-form-item label="代理商">
          {{ props.detailData.nickname }}
        </a-form-item>
        <a-form-item label="当前状态">
          <p>免单中</p>
          <p>
            已获取免单金额：<span style="color: red">{{ state.free_money }}</span>
          </p>
          <p v-for="item in state.free_coupons" :key="item.id">{{ item.name }}</p>
        </a-form-item>
        <a-form-item label="100元券数量" name="num100" required>
          <a-input placeholder="请输入数量" v-model:value="formState.num100"></a-input>
        </a-form-item>
        <a-form-item label="50元券数量" name="num50" required>
          <a-input placeholder="请输入数量" v-model:value="formState.num50"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
  labelCol: {
    xs: { span: 7 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 10 }
  }
}
interface state {
  loading: boolean
  free_money: string
  free_coupons: Array<any>
}
const state = reactive<state>({
  loading: false,
  free_money: '',
  free_coupons: []
})
interface formState {
  num50: number
  num100: number
}
let formState = reactive<formState>({
  num50: 0,
  num100: 0
})
onMounted(() => {
  queryRebate()
})
const queryRebate = () => {
  state.loading = true
  let requeryParam = {
    url: '/admin/v1/freequeue/rebate',
    method: 'post',
    data: {
      id: props.detailData.id
    }
  }
  baseService(requeryParam)
    .then((res) => {
      state.free_money = res.data.free_money
      state.free_coupons = res.data.free_coupons
    })
    .finally(() => {
      state.loading = false
    })
}

const onFormSubmit = () => {
  ruleForm.value
    .validate()
    .then(() => {
      state.loading = true
      let requeryParam = {
        url: '/admin/v1/freequeue/quit',
        method: 'post',
        data: Object.assign({ id: props.detailData.id }, formState)
      }
      baseService(requeryParam)
        .then((res: any) => {
          state.loading = false
          message.success(res.msg)
          emit('ok')
        })
        .catch((res) => {
          state.loading = false
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    })
    .catch(() => {})
}
const handleCancel = () => {
  emit('cancel')
}
</script>

<style lang="less" scoped></style>
